import React, { Component } from "react";

import RaisedTicketPopup from "views/contactUs/components/RaisedTicketPopup";
class SocialMedia extends Component {
  constructor(props) {
    super(props);
    this.state = {
      social: [
        {
          id: 1,
          img: require("views/contactUs/img/whatsapp.png"),
          title: "Talk to us on WhatsApp",
        },
        {
          id: 2,
          img: require("views/contactUs/img/chat.png"),
          title: "Chat with us",
        },
        {
          id: 3,
          img: require("views/contactUs/img/google-assis.png"),
          title: "Chat with us on Google Assist",
        },
        {
          id: 4,
          img: require("views/contactUs/img/alexa.png"),
          title: "Chat with us through Alexa",
        },
        {
          id: 5,
          img: require("views/contactUs/img/mail.png"),
          title: "Email us",
        },
        {
          id: 6,
          img: require("views/contactUs/img/callus.png"),
          title: "Call us at 1860 120 7777",
        },
        {
          id: 7,
          img: require("views/contactUs/img/ticket.png"),
          title: "Raise a Ticket",
        },
        {
          id: 7,
          img: require("views/contactUs/img/inbox.png"),
          title: "View Inbox",
        },
      ],
      israisedticketopen: false,
    };
  }

  render() {
    return (
      <div className="">
        <RaisedTicketPopup
          showTicket={this.state.israisedticketopen}
          onclose={() => this.setState({ israisedticketopen: false })}
        />
        <div className="lg:pb-24 md:pb-24 pb-16 pt-16  lg:px-32 md:px-32 px-8 ">
          <div className="grid lg:grid-cols-4 md:grid-cols-4 grid-cols-3 lg:gap-20 md:gap-20 gap-8">
            {this.state.social.map((val, index) => {
              return (
                <card
                  className="cursor-pointer block"
                  onClick={() => this.setState({ israisedticketopen: true })}
                  key={index}
                >
                  <div className="text-center">
                    <img
                      src={val.img}
                      className="w-43px h-43px m-auto object-scale-d"
                    />

                    <p className="text053C6D fsize16 sm-fsize12 line-h30 font-semibold mt-2">
                      {val.title}
                    </p>
                  </div>
                </card>
              );
            })}
          </div>
          {/* <div className="flex mt-16">
            <img src={twitter} className="mr-8" />
            <img src={facebook} className="mr-8" />
            <img src={instagram} className="mr-8" />
            <img src={linkedin} className="mr-8" />
          </div> */}
        </div>
      </div>
    );
  }
}
export default SocialMedia;
